import { useState } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { animated, useTransition } from "react-spring";
import { getCardLayoutInfo } from "../../../modules/getCardLayoutInfo";
import { pushGTMAnalyticsEvent } from "../../../modules/pushGTMAnalyticsEvent";
import { Boop } from "../Animations/Boop";
import { ImgWithFallback } from "../ImgWithFallback/ImgWithFallback";
import { ProductDetailsModal } from "../Modal/ProductDetailsModal";
import "./styles.scss";

export const CardElementDesks = ({ deskData, itemsStateObj }) => {
  const [show, setShow] = useState(false);
  const [modalDetails, setModalDetails] = useState({});
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const cardLayoutInfo = getCardLayoutInfo(3);

  const handleClick = (cardId) => {
    // Skip processing if card is marked as coming soon
    if (deskData.find((desk) => desk._id === cardId)?.metaData?.isComingSoon) {
      return;
    }

    let copy = { ...itemsStateObj.state.activeIds };
    copy.desk_model._id = cardId; // update new desk model
    copy.accessories.array = []; // clear the accessories array  (custom code)
    itemsStateObj.setState(copy);

    pushGTMAnalyticsEvent({
      event: "Item Click - MojoDesk",
      itemSelected: cardId,
      page: "desk_model",
    });
  };

  // returns an array with animation style data on each item
  const dataToDisplayTransitionArray = useTransition(deskData, {
    trail: 100,
    from: { opacity: 0, scale: 0 },
    enter: { opacity: 1, scale: 1 },
  });

  const handleSeeProductDetailsClick = (e, _modalDetails) => {
    setModalDetails({ ..._modalDetails });
    handleShowModal();
    // if(EmbedController.isEmbedded) EmbedController.sendGTMAnalyticsEvent({ 'event': 'Product Details Click - MGP' });
  };

  return (
    <Row className="CardElementDesks">
      {dataToDisplayTransitionArray((style, card, key, index) => {
        const is3LegCorner = card.section?.includes("three_leg_corner");
        const isActive = itemsStateObj.state.activeIds.desk_model._id === card._id;
        const isComingSoon = card.metaData?.isComingSoon;

        return (
          <Col xs={is3LegCorner ? 6 : cardLayoutInfo.xs} md={is3LegCorner ? 6 : cardLayoutInfo.md} key={card._id} className="mx-auto px-2">
            <animated.div style={style}>
              <Card
                className={`itemsCard justify-content-between mb-3 ${isActive ? "active" : ""} ${isComingSoon ? "coming-soon" : ""}`}
                style={{ width: cardLayoutInfo.width }}
                onClick={() => handleClick(card._id)}
                disabled={isComingSoon}
              >
                {isActive ? <img className="checkMark" alt="check mark" src="/images/checkMark.svg" /> : null}
                <div className="d-flex">
                  {card?.metaData?.isNew && !isActive && !isComingSoon && (
                    <div className="me-auto">
                      <img alt="new" className="cardBadge" src="/images/badgeNew.png" />
                    </div>
                  )}
                  {card?.metaData?.onSale && !isActive && !isComingSoon && (
                    <div className="me-auto">
                      <img alt="new" className="cardBadge" src="/images/badgeSale.png" />
                    </div>
                  )}
                  {card?.price && (
                    <div className="ms-auto">
                      <div className="price px-2">{`$${parseFloat(card.price).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`}</div>
                    </div>
                  )}
                </div>
                <div className="mx-auto my-1 d-flex">
                  <ImgWithFallback
                    className={`thumbnail ${isComingSoon ? "disabled-img" : ""}`}
                    src={card.thumbnail[0]}
                    fallback={card.thumbnail[1] || card.thumbnail[0]}
                    alt={card.displayName}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-center" style={{ height: "40px" }}>
                  <p className="mb-0 text-center" style={{ fontSize: "1.1rem" }}>
                    {card.displayName}
                  </p>
                </div>
                {/* <div className="body py-1 px-2 px-sm-3 d-flex justify-content-between align-items-center">
                  <div className="flex-column">
                    <p className="size mb-0 text-center">Wide</p>
                    <p className="spec mb-0 text-center">{`${card.displayName.split("x")[0]}"`}</p>
                  </div>
                  <div className="flex-column">
                    <p className="size mb-0 text-center">Deep</p>
                    <p className="spec mb-0 text-center">{`${card.displayName.split("x")[1]}"`}</p>
                  </div>
                </div> */}
                {card?.modalDetails && !isComingSoon && (
                  <div className="d-flex mx-auto mb-2">
                    <Boop boopType="scale" scale={1.03} timing={200}>
                      <button id="modalButton" onClick={(e) => handleSeeProductDetailsClick(e, card.modalDetails)}>
                        more info
                      </button>
                    </Boop>
                  </div>
                )}
                {card?.title && <div className="card-title">{card.title}</div>}
              </Card>
            </animated.div>
          </Col>
        );
      })}
      <ProductDetailsModal show={show} modalDetails={modalDetails} onHide={handleCloseModal} className="ProductDetailsModal" />
    </Row>
  );
};
